import { create } from 'zustand';

// Tracks the local mock server's runtime status so the titlebar control and the
// per-request Mock tab share a single source of truth. Not persisted — the Rust
// server's lifetime is tied to the app process, so status is re-synced on mount
// via getMockStatus().
export const useMockServerStore = create((set) => ({
  running: false,
  port: null,
  baseUrl: null,
  routeCount: 0,
  /** @param {{running:boolean, port:?number, baseUrl:?string, routeCount:number}} status */
  setStatus: (status) =>
    set({
      running: !!status?.running,
      port: status?.port ?? null,
      baseUrl: status?.baseUrl ?? null,
      routeCount: status?.routeCount ?? 0,
    }),
  reset: () => set({ running: false, port: null, baseUrl: null, routeCount: 0 }),
}));
